import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { I18nextProvider } from 'react-i18next';
import i18n from './utils/i18n';
import { SnackbarProvider } from 'notistack';
import {GlobalModal} from "./components/GlobalModal/GlobalModal";

window.modalWindow = false;

ReactDOM.render(
  <I18nextProvider i18n={ i18n }>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <GlobalModal><App /></GlobalModal>
    </SnackbarProvider>
  </I18nextProvider>,
  document.getElementById('root')
);

reportWebVitals();
